<template>
  <div class="gallerie desktop-fotos">
    <div class="row row-1">
      <div class="item">
        <img src="@/assets/images/gallerie/pic01.jpg" alt="" />
      </div>
      <div @click="ytVideo1" class="item clickable">
        <video src="@/assets/videos/sizzle3.mp4" loop muted autoplay></video>
        <div class="fullscreen">
          <img src="@/assets/images/youtube/fullscreen.png" alt="" />
        </div>
        <div class="text-balken">Trailer 3 ansehen</div>
      </div>
    </div>
    <div class="row row-2">
      <div class="item">
        <img src="@/assets/images/gallerie/pic03.jpg" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/gallerie/pic04.jpg" alt="" />
      </div>
      <div class="item">
        <img src="@/assets/images/gallerie/pic05.jpg" alt="" />
      </div>
    </div>
    <div class="row row-3">
      <div @click="ytVideo2" class="item clickable">
        <video src="@/assets/videos/sizzle4.mp4" loop muted autoplay></video>
        <div class="fullscreen">
          <img src="@/assets/images/youtube/fullscreen.png" alt="" />
        </div>
        <div class="text-balken">Trailer 4 ansehen</div>
      </div>
      <div class="item">
        <img src="@/assets/images/gallerie/pic07.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js'

export default {
  methods: {
    ytVideo1() {
      EventBus.$emit('open-yt-3')
    },
    ytVideo2() {
      EventBus.$emit('open-yt-4')
    },
  },
}
</script>

<style lang="scss" scoped>
.gallerie {
  max-width: 1912px;
  margin-inline: auto;
  padding-block: 2em;
  .row {
    width: 100%;
    display: grid;
    grid-template-rows: 1fr;
    &:not(:last-child) {
      margin-bottom: 1vw;
    }
    .clickable {
      cursor: pointer;
    }
    .clickable:hover {
      opacity: 0.8;
    }
    .item {
      position: relative;
      width: 100%;
      margin-inline: 0.5vw;
      img,
      video {
        width: calc(100% - 1vw);
      }
      .fullscreen {
        position: absolute;
        top: 30px;
        right: 50px;
        img {
          width: 100%;
        }
      }
      .text-balken {
        position: absolute;
        left: 0;
        bottom: 0;
        color: white;
        font-size: 1.6rem;
        font-weight: 900;
        text-transform: uppercase;
        background-color: var(--clr-red);
        padding-inline: 1em;
        padding-block: 0.2em;
      }
    }
  }
  .row-1 {
    grid-template-columns: 33.33% 66.67%;
  }
  .row-2 {
    grid-template-columns: 33.33% 33.33% 33.33%;
  }
  .row-3 {
    grid-template-columns: 66.67% 33.33%;
  }
}
</style>
